'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('home', {
      url: '/map',
      template: '<home></home>',
      theme: 'dark'
    });
}



// WEBPACK FOOTER //
// ./client/app/home/home.routes.js